import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

import Dataset from './Dataset';
import mapDataset from './mapDataset';

export interface Result {
	dataset: Dataset;
}

export default async function findDataset(client: ApiClient, productId: string): Promise<Result> {
	const request = await client.fetch(parseTemplate('products/{productId}/dataset').expand({ productId }));
	const response = await request.json();
	return { dataset: mapDataset(response.dataset) };
}
